import { type QConfigTableData } from '@exam-management/common/types';

export function getQuestionChipType(questionType: QConfigTableData['questionType']) {
  switch (true) {
    case !!questionType.single && !!questionType.itemSet:
      return 's-is';
    case questionType.single !== null && questionType.single > 0:
      return 'single';
    case questionType.itemSet !== null && questionType.itemSet > 0:
      return 'item-set';
    default:
      return null;
  }
}
